import React from 'react';
import { useTemplateStore } from './templateStore';

const checks = [
  { id: 'CRC-2.108', label: 'Line numbering enabled (CA CRC 2.108)', applies: (t: any) => t.format === 'pleading', pass: (t: any) => !!t.styleTokens?.pleadingPaper?.enabled },
  { id: 'CRC-2.111', label: 'Caption placeholders present (CA CRC 2.111)', applies: (_: any) => true, pass: (t: any) => ['COURT_NAME','COUNTY_NAME','CASE_NUMBER','PLAINTIFF','DEFENDANT','TITLE_OF_DOCUMENT'].every((k) => JSON.stringify(t.lexicalJson).includes(`{{${k}}}`)) },
  { id: 'MARGINS', label: 'Margins ≥ 1 inch', applies: (_: any) => true, pass: (t: any) => {
    const m = t.styleTokens?.margins; if (!m) return false; return m.top>=1 && m.right>=1 && m.bottom>=1 && m.left>=1;
  } },
  { id: 'FONT', label: 'Font size ≥ 12pt', applies: (_: any) => true, pass: (t: any) => (t.styleTokens?.fontSize || 0) >= 12 },
];

export const TemplateValidationPanel: React.FC<{ templateId: string }>
  = ({ templateId }) => {
  const { templates } = useTemplateStore();
  const t = templates.find(x => x.id === templateId);
  if (!t) return null;
  return (
    <div className="space-y-2">
      <h4 className="text-sm font-semibold text-gray-900 dark:text-white">Validation</h4>
      {checks.filter(c => c.applies(t)).map((c) => (
        <div key={c.id} className="text-sm flex items-center gap-2 text-gray-800 dark:text-gray-200">
          <span>{c.pass(t) ? '✅' : '⚠️'}</span>
          <span>{c.label}</span>
        </div>
      ))}
    </div>
  );
};

export default TemplateValidationPanel;


